import React from "react";
import FlowsPerProtocolReport from "./Report";
import View from "common/View";
import help from "help/viewBtaStatsSess.md";

const FlowsPerProtocol = ({returnView = null}) => (
  <View title="Active Flows Over Time" mdHelp={help} returnView={returnView}>
    <FlowsPerProtocolReport returnView={returnView} />
  </View>
);

export default FlowsPerProtocol;
